import { Stack, Typography, Box } from "@mui/material";
import DefentSheet from "@/features/HealthScore/components/DefentSheet";
import theme from "@/theme";
import { convertPxToRem } from "@/utils";

interface InfoModalProps {
  isOpen: boolean;
  handleClose: () => void;
  title: string;
  description: string;
  importanceTitle: string;
  unorderedList?: string[];
  textList?: string[];
}

export default function InfoModal({
  isOpen,
  handleClose,
  title,
  description,
  importanceTitle,
  unorderedList,
  textList,
}: InfoModalProps) {
  return (
    <DefentSheet
      expanded={isOpen}
      padding={0}
      onExpandedChange={(expanded) => {
        if (!expanded) {
          handleClose();
        }
      }}
      onClose={() => handleClose()}
    >
      <Stack width="100%">
        <Typography
          variant="h3"
          fontWeight={700}
          align="center"
          style={{ marginBottom: 25 }}
        >
          {title}
        </Typography>
        <Stack spacing={0.25} sx={{ marginBottom: convertPxToRem(25) }}>
          {(description ?? "").split("\n").map((line, i) => (
            <Typography
              key={line}
              fontWeight={600}
              fontSize={16}
              paddingLeft={i !== 0 ? convertPxToRem(16) : 0}
            >
              {line}
            </Typography>
          ))}
        </Stack>
        <Stack
          direction="column"
          padding={2}
          spacing={2}
          sx={{
            borderRadius: 2,
            backgroundColor: theme.palette.grey[100],
          }}
        >
          <Typography fontWeight={600} fontSize={16} align="center">
            {importanceTitle}
          </Typography>
          {unorderedList && (
            <Box
              style={{
                paddingLeft: 16,
                paddingRight: 16,
                fontSize: 14,
              }}
            >
              <ul>
                {unorderedList.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </Box>
          )}
          {textList?.map((text) => (
            <Typography fontWeight={500} fontSize={14} key={text}>
              {text}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </DefentSheet>
  );
}
